import { createColumnHelper } from '@tanstack/react-table'
import { ThreatTypeByCountry } from '../../types/StatTypes'

export const networkAttackColumns = () => {
  const columnHelper = createColumnHelper<ThreatTypeByCountry>()

  return [
    columnHelper.accessor('country', {
      header: 'Country',
      maxSize: 100,
      enableSorting: true,
    }),
    columnHelper.accessor('source_network', {
      header: 'Source Network',
      enableSorting: true,
    }),
    columnHelper.accessor('threat_type', {
      header: 'Threat Type',
      enableSorting: true,
    }),
    columnHelper.accessor('network_type', {
      header: 'Network Type',
      enableSorting: true,
    }),
    columnHelper.accessor('attack_volume', {
      header: 'Attacks',
      enableSorting: true,
    }),
  ]
}
